export default __webpack_public_path__ + "static/media/177.a26514ef.gif";